import React from "react"
import ContactForm from "./contactForm"
import GoogleMap from "./googleMap"
import ContactInfo from "./contactInfo"
import styles from "../styles/components/contact.module.scss"
const Contact = () => (
  <section
    className={styles.main}
    id="contact"
    aria-label="Contact Lifetime Fitness"
  >
    <div className={styles.grid}>
      <div className={styles.form}>
        <h2>Contact us</h2>
        <p>Send us a message and we'll get back to you as soon as possible!</p>
        <ContactForm />
      </div>
      <div className={styles.map}>
        <h2>Find us</h2>
        <div className={styles.infoGrid}>
          <ContactInfo />
        </div>
        <GoogleMap />
        <a
          href="https://www.google.com/maps/search/?api=1&query=Lifetime+Fitness+709%2F6+Pannipitiya+Road+Sri+Jayawardenepura+Kotte"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.directions}
        >
          Get directions on Google Maps
        </a>
      </div>
    </div>
  </section>
)
export default Contact
